/**
 * Whether this bundle is the embed app (the pages Veriform Desktop frames)
 * rather than the main app. `embedIndex.tsx` sets it once at startup.
 *
 * Some pages render in both bundles but link to authoring pages -- the
 * procedure-template editor, the report editor -- that only the embed app
 * serves. Those links go through `embedOnlyLink` so the main app does not
 * offer a link that would only send the user home.
 *
 * A module flag rather than React context because some of these links are
 * built in stores, for toasts, outside any component.
 */
let embedApp = false;

export function setIsEmbedApp(value: boolean) {
  embedApp = value;
}

export function isEmbedApp() {
  return embedApp;
}

/** `path` in the embed app; `undefined` in the main app, which does not serve it. */
export function embedOnlyLink(path: string): string | undefined {
  return embedApp ? path : undefined;
}
